import LayoutItem from "../../V2/Layouts/LayoutItem"

import Video from "@components/experiments/Video"
import React from "react"

type Props = {
  videoUrl: string
  coverImageUrl: string
  coverImageAlt?: string
  videoAlt?: string
  mobileGridOrder?: number
}

const ArticleVideo = ({
  videoUrl,
  coverImageUrl,
  coverImageAlt,
  videoAlt,
  mobileGridOrder,
}: Props) => {
  if (!videoUrl || !coverImageUrl) {
    return null
  }

  return (
    <LayoutItem
      mobileGridOrder={mobileGridOrder}
      as={Video}
      video={videoUrl}
      coverImage={coverImageUrl}
      ImageAlt={coverImageAlt}
      videoTitle={videoAlt}
      aspectRatio="16:9"
      playbackMode="manual"
      loadType="eager"
      rounded
      className="w-full"
    />
  )
}

export default ArticleVideo
